"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _styles = require("@mui/material/styles");
const _excluded = ["children", "noShadow", "negative", "onClick", "submit", "autoWidth", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const MIN_WIDTH = 100;
const StyledButton = (0, _styles.styled)(_Button.default, {
  shouldForwardProp: prop => prop !== '$noShadow' && prop !== '$autoWidth'
})(_ref => {
  let {
    $noShadow,
    $autoWidth
  } = _ref;
  return _objectSpread(_objectSpread({
    minWidth: MIN_WIDTH
  }, !!$noShadow && {
    boxShadow: 'none'
  }), !!$autoWidth && {
    width: 'auto'
  });
});

/**
 * ボタン部品
 * @prop {bool} [noShadow] - 影なしの場合true
 * @prop {bool} [autoWidth] - 幅を自動調整する場合true
 * @prop {bool} [submit] - サブミットの場合true
 * @prop {bool} [negative] - ネガティブの場合true、ポジティブの場合指定しない
 * @prop {func} [onClick] - クリック時のイベント<br/>
 * シグネチャ: ():void
 *
 */
const CButton = function (props) {
  const {
      children,
      noShadow,
      negative,
      onClick,
      submit,
      autoWidth,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(StyledButton, _extends({}, rest, {
    className: className,
    variant: "contained",
    color: negative ? 'secondary' : 'primary',
    onClick: onClick,
    type: submit ? 'submit' : undefined,
    $noShadow: noShadow,
    $autoWidth: autoWidth
  }), children);
};
CButton.propTypes = {
  noShadow: _propTypes.default.bool,
  autoWidth: _propTypes.default.bool,
  negative: _propTypes.default.bool,
  submit: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
var _default = exports.default = CButton;